import { CheckScheduledPollsServant, RedirectAfterPollForSurveyCommand } from 'capability-ng-poll';
import { ICommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';

export class CheckStudentStatusService {
  private states: {
    termsOfService: string;
    default: string;
    notAuthed: string;
    polls: string;
  };

  constructor(
    private ngCheckScheduledPollsServant: CheckScheduledPollsServant,
    private ngRedirectAfterPollForSurvey: RedirectAfterPollForSurveyCommand,
    private logoutCommand: ICommand,
    private ngMemberConfigurationDatastore: any,
    private DefaultRoute: string,
    private accountModel: AccountModel,
    private $state: ng.ui.IStateService,
    private log: any
  ) {
    this.states = {
      termsOfService: 'tos',
      default: this.DefaultRoute,
      notAuthed: 'authentication',
      polls: this.ngCheckScheduledPollsServant.route
    };
  }

  run() {
    this.__checkPollStatus();
  }

  private __checkPollStatus() {
    this.ngCheckScheduledPollsServant
      .load()
      .then(() => {
        if (this.ngCheckScheduledPollsServant.hasScheduledPolls()) {
          return this.$state.go(this.states.polls);
        }
        return this.ngRedirectAfterPollForSurvey.redirect();
      })
      .catch((err) => {
        this.log.error(err);
        this.log.issue('Unable to check intake poll status');
      });
  }

  private __userAuthenticationIssues() {
    if (this.accountModel.isSuperuser) {
      this.accountModel.clear();
      this.$state.go(this.states.notAuthed);
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./app/lib/user_modes/check_student_status_service.ts